<template>
  <div id="route-two-dir">
    <h4>{{ routeInfoTitle }}</h4>

    <!-- utility row -->
    <div class="row"></div>

    <div class="row">
      <div class="two-dir">
        <div
          v-for="(eachDir, dirIndex) in routeDetails.stops"
          :key="dirIndex"
          class="each-dir"
        >
          <div class="each-direction">
            <div class="each-stop">
              <div
                v-if="routeDetails.routec !== undefined"
                class="stop-name"
              >
                {{ routeDetails[routeDirection[dirIndex]] }}
              </div>
            </div>
            <div
              v-for="(stopItem, stopSeq) in eachDir"
              :key="stopSeq"
              class="each-stop"
            >
              <route-stop-item :stop-item="stopItem" :stopSeq="stopSeq" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- stop detail menu -->
    <div class="stop-menu">
      <StopMenu
        v-if="display"
      ></StopMenu>
    </div>
  </div>
</template>

<script>
import StopMenu from '../StopMenu/StopMenu';
import {mapActions, mapMutations, mapState} from 'vuex';
import routeDirectionEnum from '../../config/enum/routeDirectionEnum';
import RouteStopItem from "@/components/RouteInfo/RouteStopItem";

export default {
  name: "RouteInfoRoute",
  components: {RouteStopItem, StopMenu},
  computed: {
    ...mapState('routeInfo', ['routeDetails']),
    ...mapState('stopMenu', ['display']),
    routeInfoTitle() {
      const {routeDetails} = this;
      if (!routeDetails) {
        return '';
      }

      const {company, routec, startc, destinc} = routeDetails;

      if (!company || !routec || !startc || !destinc) {
        return '';
      }

      return `${company} ${routec} ${startc}↔${destinc}`;
    },
    routeDirection() {
      return routeDirectionEnum;
    }
  },
  methods: {
    ...mapActions('routeInfo', ['getRouteDetails']),
    ...mapActions('stopMenu', ['openStopMenu']),
    ...mapMutations('googleMap', [
      'openOnlyInfoWindow', 'updateBound',
      'cleanRouteLine', 'cleanMarkers',
    ]),
    ...mapActions('googleMap', ['getRouteLine']),

    // todo: move to store, and del
    async prepareOpenStopMenu(stopItem) {
      const {
        routedir, stopseq,
        // company_service_type, company_stopseq, company_routedir,
      } = stopItem;

      const {
        // startc, destinc,
        routeid, routec,
      } = this.routeDetails;

      const stopDetails = await this.openStopMenu({
        routeid,
        routedir,
        stopseq,
      });

      this.openOnlyInfoWindow(stopItem);
      this.updateBound([
        {
          ...stopItem,
          ...stopDetails,
          position: {
            lat: stopDetails.lat,
            lng: stopDetails.lng,
          },
        },
      ]);

      this.getRouteLine({
        routeid,
        routedir,
        routec,
        stopseq,
      });
    },

    async getRoute() {
      const route = await this.getRouteDetails(this.$route.params.id);
    },

    getQueryParams(query = {}) {
      console.log('getting query params: ', query);

      const {
        routedir, stopseq
      } = query;

      if (routedir && stopseq) {
        this.prepareOpenStopMenu({
          routedir, stopseq,
        });
      }
    },

    async init() {
      await this.getRoute();
      this.getQueryParams(this.$route.query);
    }
  },
  watch: {
    '$route.params.id'(id) {
      this.cleanRouteLine();
      this.getRouteDetails(id);
    },
    '$route.query'(query) {
      console.log('query updated:', query);
      this.getQueryParams(query);
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    console.log("ROUTE INFO ROUTE BEFORE DESTROY");

    this.cleanMarkers();
    this.cleanRouteLine();
  }
}
</script>

<style scoped>
.each-direction {
  width: 40%;
  float: left;
  margin: 0 5% 0 5%;
}

.each-stop:nth-child(2n) {
  background-color: rgba(200, 200, 240, 0.6);
}

.stop-index, .stop-name {
  display: inline-block;
  line-height: 28px;
}

.stop-index {
  width: 16%;
  vertical-align: top;
}

.stop-name {
  width: 80%;
}
</style>
